import React from "react";
import { BrowserRouter, Routes, Route, NavLink } from "react-router-dom";
import { AppProvider } from "@shopify/polaris";
import "@shopify/polaris/build/esm/styles.css";
import trTranslations from "@shopify/polaris/locales/tr.json";

import Dashboard from "./pages/Dashboard.jsx";
import Customers from "./pages/Customers.jsx";
import Settings from "./pages/Settings.jsx";
import Badges from "./pages/Badges.jsx";
import Challenges from "./pages/Challenges.jsx";
import Coupons from "./pages/Coupons.jsx";
import LaunchWizard from "./pages/LaunchWizard.jsx";

const NAV_ITEMS = [
  { label: "Dashboard", path: "/" },
  { label: "Müşteriler", path: "/customers" },
  { label: "Ayarlar", path: "/settings" },
  { label: "Rozetler", path: "/badges" },
  { label: "Meydan Okumalar", path: "/challenges" },
  { label: "Kuponlar", path: "/coupons" },
  { label: "🚀 Lansman Sihirbazı", path: "/launch-wizard" },
];

export default function App() {
  return (
    <AppProvider i18n={trTranslations}>
      <BrowserRouter>
        <div style={{ display: "flex", minHeight: "100vh" }}>
          <nav style={styles.sidebar}>
            <div style={styles.logo}>
              <h2 style={styles.logoText}>
                <span style={{ color: "#dbff00" }}>BO</span>{" "}
                <span style={{ color: "#fff" }}>VIP</span>{" "}
                <span style={{ color: "#ff580d" }}>Kulüp</span>
              </h2>
              <p style={styles.logoSubtext}>Hobi Puan Sistemi</p>
            </div>
            <ul style={styles.navList}>
              {NAV_ITEMS.map((item) => (
                <li key={item.path}>
                  <NavLink
                    to={item.path}
                    end={item.path === "/"}
                    style={({ isActive }) => ({
                      ...styles.navLink,
                      ...(isActive ? styles.navLinkActive : {}),
                    })}
                  >
                    {item.label}
                  </NavLink>
                </li>
              ))}
            </ul>
          </nav>

          <main style={styles.main}>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/customers" element={<Customers />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/badges" element={<Badges />} />
              <Route path="/challenges" element={<Challenges />} />
              <Route path="/coupons" element={<Coupons />} />
              <Route path="/launch-wizard" element={<LaunchWizard />} />
            </Routes>
          </main>
        </div>
      </BrowserRouter>
    </AppProvider>
  );
}

const styles = {
  sidebar: {
    width: 240,
    backgroundColor: "#1a1a2e",
    color: "#fff",
    padding: "20px 0",
    flexShrink: 0,
  },
  logo: {
    padding: "0 20px 20px",
    borderBottom: "1px solid rgba(255,255,255,0.1)",
    marginBottom: 10,
  },
  logoText: {
    margin: 0,
    fontSize: 20,
    fontWeight: 700,
  },
  logoSubtext: {
    margin: "4px 0 0",
    fontSize: 12,
    color: "rgba(255,255,255,0.5)",
  },
  navList: {
    listStyle: "none",
    padding: 0,
    margin: 0,
  },
  navLink: {
    display: "block",
    padding: "12px 20px",
    color: "rgba(255,255,255,0.7)",
    textDecoration: "none",
    fontSize: 14,
    transition: "all 0.2s",
  },
  navLinkActive: {
    color: "#dbff00",
    backgroundColor: "rgba(219,255,0,0.1)",
    borderLeft: "3px solid #dbff00",
  },
  main: {
    flex: 1,
    padding: 24,
    backgroundColor: "#f6f6f7",
    overflowY: "auto",
  },
};
